export const GoogleLoginConstants = {
	PROVIDER_NAME: 'Google',
	APP_ID: '852686964515-1k9kip2vkqnht36esc6rop66fld3ugc8.apps.googleusercontent.com',
}
